<template>
  <div class="objects">
    <div class="row" v-for="(item, i) in value" :key="i">
      <template v-for="(value, key) in item">
        <Input
          v-if="key !== 'id' && key !== 'type'"
          :key="key"
          v-model="item[key]"
          :placeholder="valueDic[key]"
        />
        <Select v-else-if="key === 'type'" v-model="item.type" :key="key">
          <Option value="number">数字</Option>
          <Option value="string">字符串</Option>
        </Select>
      </template>
      <Button icon="md-trash" @click="removeItem(i)" long class="remove-btn" />
    </div>

    <Button
      v-if="showAddButton"
      icon="md-add"
      @click="addItem"
      long
      class="add-btn"
    />
  </div>
</template>
<style lang="stylus" scoped>
.objects
  .row
    width 100%
    display flex
    margin-bottom 10px

    &>*
      margin-right 10px

    .remove-btn
      flex 0 0 50px
      margin 0
</style>
<script>
export default {
  props: ['value', 'valueDic', 'max', 'rules'],
  data() {
    return {
      showAddButton: true,
      valueList: [],
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (!newValue) return
        if (this.max && newValue.length >= this.max) {
          this.showAddButton = false
        } else {
          this.showAddButton = true
        }
        this.valueList = newValue
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addItem() {
      let newValueItem = {}
      Object.entries(this.value[0]).forEach((item) => {
        newValueItem[item[0]] = ''
      })
      // 动态增加对象数组类型字段的校验规则
      this.rules[0].fields[this.value.length] = this.rules[0].fields[0]
      this.$emit('input', [...this.value, newValueItem])
    },
    removeItem(i) {
      if (this.value.length === 1)
        return this.$Message.warning('至少需要1条数据')
      this.$delete(this.value, i)
      // 动态删除对象数组类型字段的校验规则
      delete this.rules[0].fields[this.value.length]
    },
  },
}
</script>
